import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const ordersStore = {
    actionCreators,
    reducer,
};

export default ordersStore;
